import Vue from 'vue'
import VueRouter from 'vue-router';

import routes from './router.js';
import store from './store.js';

import App from './App.vue'

Vue.config.productionTip = false;
Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
});

// Just to keep track of the prevous route.
router.beforeEach((to, from, next) => {
  localStorage.setItem('previousRoute', from.path);
  next();
})

Vue.use(VueRouter);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
